import { cva } from '@vizit/theme';

export enum ContextMenuMode {
  Light = 'light',
  Dark = 'dark',
}

/**
 * Shared context menu trigger button classes
 * Used by both AssetContextMenu and CollectionMenuDropdown
 */
export const contextMenuTriggerClasses = cva({
  base: [
    'flex items-center justify-center w-9 h-9 rounded-none px-0 py-0',
    'border-none outline-none',
    'focus-visible:ring-2 focus-visible:ring-gray-utility-700 focus-visible:ring-offset-2',
  ],
  variants: {
    mode: {
      [ContextMenuMode.Light]: ['bg-white hover:bg-gray-utility-50', 'text-gray-utility-600'],
      [ContextMenuMode.Dark]: ['bg-overlay-action hover:bg-overlay-action-hover', 'text-quinary'],
    },
  },
  defaultVariants: {
    mode: ContextMenuMode.Light,
  },
});
